//#region Imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base-service.service';
import { LoginDto } from '../model/loginDto';
import { LoginResultDto } from '../model/loginResultDto';

//#endregion Imports

@Injectable({
  providedIn: 'root'
})

export class LoginService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
     //#endregion Constructor

    //#region Public Methods
    public LoginAccess(loginDto: LoginDto): Observable<GenericMemberResponsePortalResponseDto<LoginResultDto>> {
        return this.Post('/login', loginDto);
    }
    //#endregion Public Methods
}
